import { Initializer } from 'common/types/initializers';
import { getSupportChatConfig } from 'common/support-chat/getSupportChatConfig';
import App from 'common/backbone-app';
import { getLoggedUserInfo } from 'common/support-chat/utils';
import { onSupportChatOpen, SUPPORT_CHAT_WIDGET_ID } from 'common/support-chat/index';

export const SupportChatWidgetInitializer = (): Initializer => {
  return {
    destroy: () => {
      App.off(Wahanda.Event.SALESFORCE_BOT_OPEN);
    },
    render,
  };
};

/*
The goal of this render is to define a listener for the support chat entrypoint
Despite the naming, it does not actually render the chat widget, but it rather sets up
an event handler to do it upon the related event.
 */
const render = () => {
  const el = getOrCreateRootElement();
  const conf = getSupportChatConfig();
  const userInfo = getLoggedUserInfo();
  // avoids mulitple registered listeners
  App.off(Wahanda.Event.SALESFORCE_BOT_OPEN);
  App.on(Wahanda.Event.SALESFORCE_BOT_OPEN, onSupportChatOpen(userInfo, conf, el));
  return el;
};

function getOrCreateRootElement() {
  const rootNode = document.getElementById(SUPPORT_CHAT_WIDGET_ID);
  if (rootNode) {
    return rootNode!;
  }
  const node = document.createElement('div');
  node.id = SUPPORT_CHAT_WIDGET_ID;
  document.body.appendChild(node);
  return node;
}
